import Layout from "../shared/components/Layout";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const PersonalForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm( {mode: 'onChange'});

  const navigate = useNavigate();

  const onSubmit = (data) => {
    console.log(data);
    sessionStorage.setItem('customer',JSON.stringify(data));
    navigate("/tu-tarjeta-ideal");
  };

  const selectHobbies = (input) => {
    document.getElementById(`${input}Input`).checked ? document.getElementById(input).classList.remove('cheked-filtro') : document.getElementById(input).classList.add('cheked-filtro')
  }

  return (
    <Layout>
      <section className="content-form">
        <h1>Conoce la tarjeta creada especialmente para ti</h1>
        <p>Con tus datos básicos buscaremos una tarjeta de crédito que se ajuste a tus necesidades. Cuando  la conozcas, decides si continúas con la solicitud.</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* register your input into the hook by invoking the "register" function */}
          <fieldset className="bc-fieldset">  
          <legend>Datos básicos</legend>
          <div className="bc-input-group">
            <label htmlFor="nombre">Nombre y apellido</label>
            <input id="nombre" className="bc-input" {...register("nombre", { required: true })} />
          </div>
          {errors.nombre && <span>This field is required</span>}

          {/* include validation with required or other standard HTML validation rules */}
          <div className="bc-input-group">
            <label htmlFor="edad">Edad</label>
          <input id="edad" className="bc-input" type="number" {...register("edad", { required: true })} />
          </div>
          {/* errors will return when field validation fails  */}
          {errors.edad && <span>This field is required</span>}
          <div className="bc-input-group">
            <label htmlFor="celular">Celular</label>
            <input id="celular" className="bc-input" {...register("celular", { required: true })} />
          </div>
          {errors.celular && <span>This field is required</span>}
          <div className="bc-input-group">
            <label htmlFor="correo">Correo</label>
            <input id="correoInput" className="bc-input" type="email" {...register("correo", { required: true })} />
          </div>
          {errors.correo && <span>This field is required</span>}
          </fieldset>

          <fieldset className="bc-fieldset hobbies-tc">
            <legend>Quiero mi tarjeta para:</legend> 
            <label id="movie" className="options-hobbies">
                <input id="movieInput" type="checkbox" className="bc-check-filtro" value="cine" onClick={() => selectHobbies('movie') } />
                <em className="bc-icon">movie</em>
                Cine
                <span className="cancelar-filtro" >
                    <i className="bc-icon ml-1" >error</i>
                </span>
            </label>
            <label id="hand" className="options-hobbies">
                <em className="bc-icon">hand-index</em>
                <input id="handInput" type="checkbox" className="bc-check-filtro" value="primera tarjeta" onClick={() => selectHobbies('hand') }/> 
                Primera tarjeta
                <span className="cancelar-filtro">
                    <i className="bc-icon ml-1">error</i>
                </span>
            </label>
            <label id="restaurant" className="options-hobbies">
                <em className="bc-icon">restaurant</em>
                <input id="restaurantInput" type="checkbox" className="bc-check-filtro" value="restaurante" onClick={() => selectHobbies('restaurant') }/> 
                Restaurantes
                <span className="cancelar-filtro">
                    <i className="bc-icon ml-1">error</i>
                </span>
            </label>
            <label id="vip" className="options-hobbies">
                <em className="bc-icon">vip</em>
                <input id="vipInput" type="checkbox" className="bc-check-filtro" value="vip" onClick={() => selectHobbies('vip') }/> 
                Salas VIP
                <span className="cancelar-filtro">
                    <i className="bc-icon ml-1">error</i>
                </span>
            </label>
            <label id="card" className="options-hobbies">
                <em className="bc-icon">cards</em>
                <input id="cardInput" type="checkbox" className="bc-check-filtro" value="premium" onClick={() => selectHobbies('card')}/> 
                Tarjetas premium 
                <span className="cancelar-filtro">
                    <i className="bc-icon ml-1 ">error</i>
                </span>
            </label>
          </fieldset>

          <button
          type="submit"
          className="bc-button-primary submit-btn"
          disabled={!isValid}
        >
          Conocer mi tarjeta ideal
        </button>
        </form>
      </section>
    </Layout>
  );
};

export default PersonalForm;
